/**
 * Sticky header helper.
 * - Sets data-scrolled on [data-sticky-header] once the page is scrolled past 160px (cleared above 24px).
 *   That adds a shadow and tightens the header row (the Delivery/Shipping/Pickup toggle and aisle bar stay visible).
 * - Sets data-scroll-up while the shopper scrolls up (the aisle bar itself always stays visible).
 * Hiding rows changes the header height, which can nudge the scroll position. A short lock after each
 * change plus a minimum scroll distance keeps that nudge from flipping the state back (no flicker).
 */
const header = document.querySelector('[data-sticky-header]');

if (header) {
  const ON = 160;
  const OFF = 24;
  const MIN_DELTA = 30;
  const LOCK_MS = 350;
  let ticking = false;
  let anchorY = window.scrollY;
  let lockedUntil = 0;

  const setAttr = (name, on) => {
    if (header.hasAttribute(name) === on) return false;
    header.toggleAttribute(name, on);
    lockedUntil = performance.now() + LOCK_MS;
    return true;
  };

  const update = () => {
    ticking = false;
    const y = window.scrollY;

    if (performance.now() < lockedUntil) {
      anchorY = y;
      return;
    }

    if (y > ON) setAttr('data-scrolled', true);
    else if (y < OFF) {
      setAttr('data-scrolled', false);
      header.removeAttribute('data-scroll-up');
      anchorY = y;
      return;
    }

    const delta = y - anchorY;
    if (delta <= -MIN_DELTA) {
      setAttr('data-scroll-up', true);
      anchorY = y;
    } else if (delta >= MIN_DELTA) {
      setAttr('data-scroll-up', false);
      anchorY = y;
    }
  };

  window.addEventListener(
    'scroll',
    () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    },
    { passive: true },
  );
  update();
}
